module.exports = __webpack_public_path__ + "img/voto_h.df7c78c2.png";